export const ClubModeratorIcon = ({
  ...props
}: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 0.5C4.89552 0.5 2.69729 1.76534 1.57504 3.57553C0.49968 5.31009 0.499865 7.43123 0.499997 8.94989C0.499999 8.96667 0.5 8.98337 0.5 9C0.5 9.01663 0.499999 9.03333 0.499997 9.05011C0.499865 10.5688 0.49968 12.6899 1.57504 14.4245C2.69729 16.2347 4.89552 17.5 9 17.5C13.1045 17.5 15.3027 16.2347 16.425 14.4245C17.5003 12.6899 17.5001 10.5688 17.5 9.05011L17.5 9L17.5 8.94989C17.5001 7.43123 17.5003 5.31009 16.425 3.57553C15.3027 1.76534 13.1045 0.5 9 0.5Z"
      fill="#526C03"
      stroke="white"
    />
    <g clipPath="url(#clip0_71_4338)">
      <path
        d="M9.00075 11.5044L6.17955 13.0836L6.80955 9.91239L4.43555 7.71719L7.64635 7.33639L9.00075 4.40039L10.3551 7.33639L13.5659 7.71719L11.1919 9.91239L11.8219 13.0836L9.00075 11.5044Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_71_4338">
        <rect
          width="9.6"
          height="9.6"
          fill="white"
          transform="translate(4.2002 4.2002)"
        />
      </clipPath>
    </defs>
  </svg>
)
